import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=1a3e7b00&scoped=true"
import script from "./StockList.vue?vue&type=script&lang=js"
export * from "./StockList.vue?vue&type=script&lang=js"
import style0 from "./StockList.vue?vue&type=style&index=0&id=1a3e7b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3e7b00",
  null
  
)

export default component.exports